import React from 'react';

const GridIcon = () => (
  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 1.71429C0 0.767411 0.783399 0 1.75 0H12.25C13.2152 0 14 0.767411 14 1.71429V10.2857C14 11.2312 13.2152 12 12.25 12H1.75C0.783399 12 0 11.2312 0 10.2857V1.71429ZM5.25 3.42857H13.125V1.71429C13.125 1.24098 12.734 0.857143 12.25 0.857143H5.25V3.42857ZM4.375 0.857143H1.75C1.26684 0.857143 0.875 1.24098 0.875 1.71429V3.42857H4.375V0.857143ZM0.875 4.28571V7.71429H4.375V4.28571H0.875ZM0.875 8.57143V10.2857C0.875 10.7598 1.26684 11.1429 1.75 11.1429H4.375V8.57143H0.875ZM5.25 11.1429H12.25C12.734 11.1429 13.125 10.7598 13.125 10.2857V8.57143H5.25V11.1429ZM13.125 7.71429V4.28571H5.25V7.71429H13.125Z"
      fill="currentColor"
    />
  </svg>
);

export default GridIcon;
